import {Component, Input} from '@angular/core';
import {
    MatDatepickerToggle,
    MatDateRangeInput,
    MatDateRangePicker,
    MatEndDate,
    MatStartDate
} from "@angular/material/datepicker";
import {MatFormField, MatHint, MatLabel, MatSuffix} from "@angular/material/input";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'antm-date-range-picker',
    imports: [
        MatDateRangeInput,
        MatDateRangePicker,
        MatDatepickerToggle,
        MatEndDate,
        MatFormField,
        MatHint,
        MatLabel,
        MatStartDate,
        MatSuffix,
        ReactiveFormsModule
    ],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
})
export class DateRangePickerComponent {

  @Input() form: FormGroup;
  @Input() startControlName!: string;
  @Input() endControlName!: string;
  @Input() placeholder!: string;
}
